import React from "react";
import { Button } from "@chakra-ui/react";
import { RiCustomerService2Line } from "react-icons/ri";
export default function CreateAppointmentButton({
  appointment,
  task,
  isVisible = true,
  ...props
}) {
  if (!isVisible) return null;
  return (
    <Button leftIcon={<RiCustomerService2Line />} {...props}>
      {task.appointment_date ? "Rand. Güncelle" : "Randevu Ayarla"}
    </Button>
  );
}
